@if (visible()) {
  <div class="notification" [class]="type()" role="alert">
    <span class="msg" [innerHTML]="message()"></span>
    <button class="close" (click)="hide()" aria-label="Dismiss">×</button>
  </div>
}